import React from 'react';
import { Link } from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import Preloader from '../../../core/Preloader';
import { viewData, processFileData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const Url='/staff';
const backUrl='/staffs'+Url;
const staffUrl='/staffDependence'; 

class AddEditAction extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            graduation:'',
            designation:'',
            name:'',
            permanent_address:'',
            permanent_address_pincode:'',
            communication_address_pincode:'',
            status:1,
            email_id:'',
            aadhar_no:'',
            whats_app_no:'',
            dob:'',
            start_year:'',
            end_year:'',
            mobile:'',
            landline:'',
            joining_date:'',
            blood_group_id:'',
            marital_status:'single',
            gender:'male',
            father_name:'',
            father_occupation:'',
            mother_name:'',
            mother_occupation:'',
            communication_address:'',
            community_id:'',
            religion_id:'',
            semester_name:'', 
            staff_type_id:'',
            course_year_id:'',
            course_sem_id:'',
            husband_name:'',
            husband_occupation:'', 
            roleData:[],
            departmentData:[],
            bloodGroupData:[],
            communityData:[],
            religionData:[],
            staffTypeData:[],
            photo:'',
            staff_role_id:'',
            department_id: '',
            caste:'', 
            preloader:this.props.match.params.id?true:false,
            title:this.props.match.params.id?'Edit':'New'
        };
        this.validator = new SimpleReactValidator(); 
        this.handleChangeDobDate=this.handleChangeDobDate.bind(this);
        this.handleChangeJoiningDate=this.handleChangeJoiningDate.bind(this);
    }


    componentDidMount(){
        viewData(staffUrl).then((res)=>{
            if(res.data.status===200){
                const data=res.data;
                this.setState({ 
                    bloodGroupData:data.bloodGroupData,
                    communityData:data.communityData,
                    religionData:data.religionData,
                    roleData:data.roleData,
                    departmentData:data.departmentData,
                    staffTypeData:data.staffType,
                    preloader:false
                });
                if(this.props.match.params.id){
                    viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                        if(res.data.status===200){
                            let data=res.data.data; 
                            this.setState({
                                staff_type_id:data.staff_type_id?data.staff_type_id:'', 
                                name:data.name,
                                email_id:data.email_id,
                                id_no:data.id_no,
                                aadhar_no:data.aadhar_no, 
                                graduation:data.graduation,
                                designation:data.designation,
                                whats_app_no:data.whats_app_no,
                                mobile:data.mobile,
                                landline:data.landline,
                                gender:data.gender==0?'male':'female',
                                communication_address:data.communication_address,
                                communication_address_pincode:data.communication_address_pincode,
                                permanent_address:data.permanent_address,
                                permanent_address_pincode:data.permanent_address_pincode,
                                father_name:data.father_name,
                                father_occupation:data.father_occupation,
                                husband_name:data.husband_name,
                                husband_occupation:data.husband_occupation,
                                mother_name:data.mother_name,
                                mother_occupation:data.mother_occupation,
                                community_id:data.community_id,
                                religion_id:data.religion_id, 
                                marital_status:data.marital_status==0?'married':'single', 
                                status:data.status,
                                blood_group_id:data.blood_group_id, 
                                staff_role_id:data.role_id, 
                                department_id:data.department_id,
                                dob:data.dob!='0000-00-00' ?moment(new Date(data.dob)):'',
                                joining_date:moment(new Date(data.joining_date)),
                                photo:data.photo,
                                preloader:false, 
                            }); 
                        }
                    });
                } 
            }
        });
    }

    handleChangeDobDate(date) {
        this.setState({ dob: moment(date)});
    }
 
    handleChangeJoiningDate(date) {
        this.setState({ joining_date: moment(date)});
    }
  

    setStateFromInput=(event)=> {
        var obj = {};
        const radioVal=['status'];
        obj[event.target.name] = radioVal.includes(event.target.name)?event.target.value==0?1:0:event.target.value;
        this.setState(obj);
    }

    submitForm=()=>{
        if(this.validator.allValid()){
            let {name,email_id,aadhar_no,staff_type_id,dob,designation,whats_app_no,mobile,landline,gender,communication_address,communication_address_pincode,permanent_address_pincode,permanent_address,father_name,father_occupation,mother_name,mother_occupation,community_id,religion_id,joining_date,marital_status,status,blood_group_id,id_no,staff_role_id,department_id,husband_name,
                husband_occupation,caste} =this.state;
            let formData = new FormData();
            let imagefile = document.querySelector('#upload');
            //if(imagefile.files[0])
            formData.append('pic', imagefile.files[0]);
                
            formData.append('name',name);
            formData.append('email_id',email_id);
            formData.append('id_no',id_no);
            formData.append('aadhar_no',aadhar_no);
            formData.append('staff_type_id',staff_type_id);
            formData.append('dob',moment(dob));
            formData.append('designation',designation);
            formData.append('whats_app_no',whats_app_no);
            formData.append('mobile',mobile);
            formData.append('landline',landline);
            formData.append('gender',gender=='male'?0:1);
            formData.append('communication_address',communication_address);
            formData.append('communication_address_pincode',communication_address_pincode);
            formData.append('permanent_address_pincode',permanent_address_pincode);
            formData.append('permanent_address',permanent_address);
            formData.append('father_name',father_name);
            formData.append('father_occupation',father_occupation);
            formData.append('husband_name',husband_name);
            formData.append('husband_occupation',husband_occupation);
            formData.append('mother_name',mother_name);
            formData.append('mother_occupation',mother_occupation);
            formData.append('community_id',community_id);
            formData.append('religion_id',religion_id);
            formData.append('joining_date',moment(joining_date));
            formData.append('marital_status',marital_status=='married'?0:1);
            formData.append('status',status);
            formData.append('blood_group_id',blood_group_id);
            formData.append('staff_role_id',staff_role_id);
            formData.append('department_id',department_id);
            formData.append('caste',caste);
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            processFileData(Url+para,formData).then((res)=>{
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
 
  
    render() {
        let {title,preloader,staff_type_id,name,id_no,email_id,aadhar_no, whats_app_no,
            mobile,
            landline,
            dob,
            joining_date,
            father_name,
            father_occupation,
            mother_name,
            communication_address,
            permanent_address_pincode,
            permanent_address,
            communication_address_pincode,
            status,
            community_id,
            religion_id,
            mother_occupation,
            communityData,
            religionData, 
            marital_status,
            husband_name,
            roleData,
            departmentData,
            staff_role_id,
            department_id,
            husband_occupation,designation,blood_group_id,bloodGroupData,gender,photo,staffTypeData} = this.state;
        let role=permissionCheck('student',title);
        if(!role)
            return <Nopermission/>;
        const nameValid= this.validator.message('Course',name, 'required');
        const id_noValid= this.validator.message('Course',id_no, 'required');
        const aadhar_noValid= this.validator.message('Course',aadhar_no, 'required');
        const email_idValid= this.validator.message('Course',email_id, 'required');
        const staff_type_idValid= this.validator.message('Course',staff_type_id, 'required'); 
        const genderValid= this.validator.message('Gender',gender, 'required');
        const dobValid= this.validator.message('Date Of Birth',dob, 'required');
        const joining_dateValid= this.validator.message('Joining Date',joining_date, 'required');
        const community_idValid= this.validator.message('Community',community_id, 'required');
        const religion_idValid= this.validator.message('Religion',religion_id, 'required');/* 
        const father_nameValid= this.validator.message('Father Name',father_name, 'required');
        const father_occupationValid= this.validator.message('Father Occupation',father_occupation, 'required'); */
        const mother_nameValid= this.validator.message('Mother Name',mother_name, 'required');
        const mother_occupationValid= this.validator.message('Mother Occupation',mother_occupation, 'required');
        /*const whats_app_noValid= this.validator.message('WhatsApp No',whats_app_no, 'numeric');
        const mobileValid= this.validator.message('Mobile',mobile, 'numeric');
        const landlineValid= this.validator.message('landline',landline, 'numeric');*/ 
        const communication_addressValid= this.validator.message('communication_address',communication_address, 'required');
        const communication_address_pincodeValid= this.validator.message('communication_address_pincode',communication_address_pincode, 'required');
        const permanent_addressValid= this.validator.message('Permanent Address',permanent_address, 'required');
        const permanent_address_pincodeValid= this.validator.message('Permanent Address Pincode',permanent_address_pincode, 'required');
        const marital_statusValid= this.validator.message('Marital Status',marital_status, 'required');
        /* const graduationValid= this.validator.message('First Graduation',graduation, 'required');*/
        const designationValid= this.validator.message('Designation',designation, 'required'); 
        const statusValid= this.validator.message('Status',status, 'required|numeric');
        const blood_group_idValid= this.validator.message('Blood Group',blood_group_id, 'required'); 
        const staff_role_idValid= this.validator.message('Role',staff_role_id, 'required'); 
        const department_idValid= this.validator.message('Department',department_id, 'required');  
   
        return (
            <div id="page_content_inner">
                <h3 className="heading_b uk-margin-bottom">{title} Staff</h3>
                <div className="md-card">
                    <div className="md-card-content large-padding">

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Name<span className="req">*</span></label>
                                    <input type="text" name="name" value={name} onChange={this.setStateFromInput} className={ `md-input ${nameValid ?'md-input-danger':''}`} /> 
                                    {nameValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${id_no ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="ID No">ID No<span className="req">*</span></label>
                                    <input type="text" name="id_no" value={id_no} onChange={this.setStateFromInput} className={ `md-input ${id_noValid ?'md-input-danger':''}`} /> 
                                    {id_noValid} 
                                </div>
                            </div>
                       
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${email_id ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Email Id">Email Id<span className="req">*</span></label>
                                    <input type="text" name="email_id" value={email_id} onChange={this.setStateFromInput} className={ `md-input ${email_idValid ?'md-input-danger':''}`} /> 
                                    {email_idValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${aadhar_no ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Aadhar No">Aadhar No<span className="req">*</span></label>
                                    <input type="text" name="aadhar_no" value={aadhar_no} onChange={this.setStateFromInput} className={ `md-input ${aadhar_noValid ?'md-input-danger':''}`} /> 
                                    {aadhar_noValid} 
                                </div>
                            </div>
                        </div>

                       

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${dob ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Aadhar No">DOB<span className="req">*</span></label>
                                    <DatePicker showYearDropdown showMonthDropdown scrollableYearDropdown  yearDropdownItemNumber={20} selected={dob} dateFormat="DD/MM/YYYY" className={ `datepicker md-input ${dobValid ?'md-input-danger':''}`}  onChange={this.handleChangeDobDate} /> 
                                    {dobValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${joining_date ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Aadhar No">Joining Date<span className="req">*</span></label>
                                    <DatePicker showYearDropdown showMonthDropdown scrollableYearDropdown  yearDropdownItemNumber={20} selected={joining_date} dateFormat="DD/MM/YYYY"  className={ `datepicker md-input ${joining_dateValid ?'md-input-danger':''}`} onChange={this.handleChangeJoiningDate} /> 
                                    {joining_dateValid} 
                                </div>
                            </div>
 
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${designation ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Designation">Designation<span className="req">*</span></label>
                                    <input type="text" name="designation" value={designation} onChange={this.setStateFromInput} className={ `md-input ${designationValid ?'md-input-danger':''}`} /> 
                                    {designationValid} 
                                </div>
                            </div> 

                            <div className="uk-width-medium-1-4"> 
                                <div className="md-input-wrapper md-radio">
                                    <span className="md-radio">
                                        <input checked={gender=='male'?1:0} onChange={this.setStateFromInput} type="radio" name="gender" id="radio_demo_1" value="male" />
                                        <label htmlFor="radio_demo_1" className="inline-label">Male</label>
                                        <input type="radio" name="gender" id="radio_demo_2" checked={gender=='female'?1:0} onChange={this.setStateFromInput} value="female" />
                                        <label htmlFor="radio_demo_2" className="inline-label">Female</label>
                                    </span>
                                    {genderValid} 
                                </div>
                            </div> 
                        </div>

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${whats_app_no ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="WhatsApp No">WhatsApp No</label>
                                    <input type="text" name="whats_app_no" value={whats_app_no} onChange={this.setStateFromInput} className={ 'md-input'} /> 
                    
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${mobile ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Mobile">Mobile</label>
                                    <input type="text" name="mobile" value={mobile} onChange={this.setStateFromInput} className={ 'md-input'} /> 
                                    
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${landline ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="landline">landline</label>
                                    <input type="text" name="landline" value={landline} onChange={this.setStateFromInput} className={ 'md-input'} /> 
                                    
                                </div>
                            </div>
                            <div className="uk-width-medium-1-4"> 
                                <div className="md-input-wrapper md-radio">
                                    <span className="md-radio">  
                                        <input checked={marital_status=='married'?true:false} onChange={this.setStateFromInput} type="radio" name="marital_status" id="marital_status_1" value="married" />
                                        <label htmlFor="marital_status_1" className="inline-label">Married</label>
                                        <input type="radio" name="marital_status" id="marital_status_2" checked={marital_status=='single'?1:0} onChange={this.setStateFromInput} value="single" />
                                        <label htmlFor="marital_status_2" className="inline-label">Single</label>
                                    </span>
                                    {marital_statusValid} 
                                </div>
                            </div>  
                        </div>

                        <div className="uk-grid">

                            { 
                                marital_status=='single' &&

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${father_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Father Name">Father Name<span className="req">*</span></label>
                                    <input type="text" name="father_name" value={father_name} onChange={this.setStateFromInput} className='md-input' /> 
                                </div>
                            </div>
                            }
                            { 
                                marital_status=='married' &&  gender=='male'  &&

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${father_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Father Name">Father Name<span className="req">*</span></label>
                                    <input type="text" name="father_name" value={father_name} onChange={this.setStateFromInput}className='md-input' /> 
                                </div>
                            </div>
                            }

                            { 
                                marital_status=='single' &&
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${father_occupation ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Father Occupation">Father Occupation<span className="req">*</span></label>
                                    <input type="text" name="father_occupation" value={father_occupation} onChange={this.setStateFromInput} className='md-input' /> 
                                </div>
                            </div>

                            }
                            { 
                                marital_status=='married' &&  gender=='male'  &&
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${father_occupation ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Father Occupation">Father Occupation<span className="req">*</span></label>
                                    <input type="text" name="father_occupation" value={father_occupation} onChange={this.setStateFromInput} className='md-input' /> 
                                </div>
                            </div> 
                            }

                            { 
                                marital_status=='married' &&  gender=='female' &&

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${husband_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Husband Name">Husband Name<span className="req">*</span></label>
                                    <input type="text" name="husband_name" value={husband_name} onChange={this.setStateFromInput} className='md-input' /> 
                                </div>
                            </div>
                            }
                            { 
                                marital_status=='married' &&  gender=='female' &&
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${husband_occupation ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Husband Occupation">Husband Occupation<span className="req">*</span></label>
                                    <input type="text" name="husband_occupation" value={husband_occupation} onChange={this.setStateFromInput}className='md-input' /> 
                                </div>
                            </div> 
                            }
  

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${mother_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Mother Name">Mother Name<span className="req">*</span></label>
                                    <input type="text" name="mother_name" value={mother_name} onChange={this.setStateFromInput} className={ `md-input ${mother_nameValid ?'md-input-danger':''}`} /> 
                                    {mother_nameValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${mother_occupation ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Mother Occupation">Mother Occupation<span className="req">*</span></label>
                                    <input type="text" name="mother_occupation" value={mother_occupation} onChange={this.setStateFromInput} className={ `md-input ${mother_occupationValid ?'md-input-danger':''}`} /> 
                                    {mother_occupationValid} 
                                </div>
                            </div>
                        </div>
                             
                        
                        
                        <div className="uk-grid">
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${communication_address ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Communication Address">Communication Address<span className="req">*</span></label>
                                    <input type="text" name="communication_address" value={communication_address} onChange={this.setStateFromInput} className={ `md-input ${communication_addressValid ?'md-input-danger':''}`} /> 
                                    {communication_addressValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${communication_address_pincode ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Communication Address Pincode">Communication Address Pincode<span className="req">*</span></label>
                                    <input type="text" name="communication_address_pincode" value={communication_address_pincode} onChange={this.setStateFromInput} className={ `md-input ${communication_address_pincodeValid ?'md-input-danger':''}`} /> 
                                    {communication_address_pincodeValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${permanent_address ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Permanent Address">Permanent Address<span className="req">*</span></label>
                                    <input type="text" name="permanent_address" value={permanent_address} onChange={this.setStateFromInput} className={ `md-input ${permanent_addressValid ?'md-input-danger':''}`} /> 
                                    {permanent_addressValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${permanent_address_pincode ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Permanent Address Pincode">Permanent Address Pincode<span className="req">*</span></label>
                                    <input type="text" name="permanent_address_pincode" value={permanent_address_pincode} onChange={this.setStateFromInput} className={ `md-input ${permanent_address_pincodeValid ?'md-input-danger':''}`} /> 
                                    {permanent_address_pincodeValid} 
                                </div>
                            </div> 
                        </div>

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${staff_type_id ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1" className={ `datepicker md-input ${staff_type_idValid ?'md-input-danger':''}`} name="staff_type_id" onChange={this.setStateFromInput} value={staff_type_id}>
                                        <option value="">Select Staff Type</option>
                                        {
                                            staffTypeData && staffTypeData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.staff_type_id} >{val.type_name}</option>
                                                );
                                            })
                                        }  
                                    </select> 
                                    {staff_type_idValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${community_id ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1"  className={ `datepicker md-input ${community_idValid ?'md-input-danger':''}`} name="community_id" onChange={this.setStateFromInput} value={community_id}>
                                        <option value="">Select Community</option>
                                        {
                                            communityData && communityData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.community_id} >{val.community_name}</option>
                                                );
                                            })
                                        } 
                                    </select> 
                                    {community_idValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${religion_id ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1"  className={ `datepicker md-input ${religion_idValid ?'md-input-danger':''}`} name="religion_id" onChange={this.setStateFromInput} value={religion_id}>
                                        <option value="">Select Religion</option>
                                        {
                                            religionData && religionData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.religion_id} >{val.religion_name}</option>
                                                );
                                            })
                                        } 
                                    </select> 
                                    {religion_idValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${blood_group_id ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1"  className={ `datepicker md-input ${blood_group_idValid ?'md-input-danger':''}`} name="blood_group_id" onChange={this.setStateFromInput} value={blood_group_id}>
                                        <option value="">Select Blood Group</option>
                                        {
                                            bloodGroupData && bloodGroupData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.blood_group_id} >{val.blood_group}</option>
                                                );
                                            })
                                        } 
                                    </select> 
                                    {blood_group_idValid} 
                                </div>
                            </div>
                        </div>
                        
                        <div className="uk-grid"> 
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${department_id ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1"  className={ `datepicker md-input ${department_idValid ?'md-input-danger':''}`} name="department_id" onChange={this.setStateFromInput} value={department_id}>
                                        <option value="">Select Department</option>
                                        {
                                            departmentData && departmentData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.department_id} >{val.department_name}</option>
                                                );
                                            })
                                        } 
                                    </select> 
                                    {department_idValid} 
                                </div>
                            </div> 

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${staff_role_id ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1"  className={ `datepicker md-input ${staff_role_idValid ?'md-input-danger':''}`} name="staff_role_id" onChange={this.setStateFromInput} value={staff_role_id}>
                                        <option value="">Select Role</option>
                                        {
                                            roleData && roleData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.role_id} >{val.rolename}</option>
                                                );
                                            })
                                        } 
                                    </select> 
                                    {staff_role_idValid} 
                                </div>
                            </div> 

                            <div className="uk-width-medium-1-4"> 
                                <div className="md-input-wrapper md-radio">
                                    <span className="md-radio">
                                        <input checked={status==1?1:0} onChange={this.setStateFromInput} type="radio" name="status" id="status_1" value="0" />
                                        <label htmlFor="status_1" className="inline-label">Active</label>
                                        <input type="radio" name="status" id="status_2" checked={status==0?1:0} onChange={this.setStateFromInput} value="1" />
                                        <label htmlFor="status_2" className="inline-label">In-Active</label>
                                    </span>
                                    {statusValid} 
                                </div>
                            </div> 
                        </div>
                        
                        <div className="uk-grid">
                     
                            <div className="uk-width-1-4">
                                { photo &&
                                            <div className="thumbnail">
                                                <img style={{width:'100px',height:'100px'}} src={photo} alt="user avatar" className=""/>
                                            </div>
                                }
                            </div>
                        </div>
                        <div className="uk-grid">
                            <div className="uk-width-1-4">
                                <div className="uk-form-file md-btn md-btn-small md-btn-primary">
                                Staff Photo
                                    <input id="upload" type="file"/>
                                </div> 
                            </div> 
                        </div>
     
                        <div className="uk-grid">
                            <div className="uk-width-1-1 btn-right-align">
                                <Link to={backUrl} className="md-btn md-btn-small md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                <button type="button" onClick={this.submitForm} className="md-btn md-btn-small md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Staff/Staff/addEdit.js